module.exports = __webpack_public_path__ + "img/6.a10b13f.jpg";